import { create } from 'zustand';

interface ArduinoSetupDialogState {
  open: boolean;
  startupPromptShown: boolean;
  show: () => void;
  close: () => void;
  showStartupPromptOnce: () => void;
}

export const useArduinoSetupDialogStore = create<ArduinoSetupDialogState>((set, get) => ({
  open: false,
  startupPromptShown: false,
  show: () => set({ open: true }),
  close: () => set({ open: false }),
  showStartupPromptOnce: () => {
    if (get().startupPromptShown) {
      return;
    }
    set({ startupPromptShown: true, open: true });
  },
}));
